import React, { useEffect, useContext, useState } from 'react';
//import { Col, Row, Card, Form } from 'react-bootstrap';
import { Col, Row, Card, Form, Button } from 'react-bootstrap';
import { ProductContext } from '../../ProductProvider';
import axios from "axios";
import { fetchAuthSession } from 'aws-amplify/auth';
import { Breadcrumb } from 'react-bootstrap';
import Preloader from "../../components/Preloader/Preloader";
import {Helmet} from 'react-helmet-async';
import { phoneCode } from "../../ProData";
import { useSnackbar } from 'notistack';
import ProfileImage from '../../components/profile/ProfileImages';
import logo from '../../images/logo/VJLOGO.png';

const config = require('../../config.json');
const dobRegex=/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
const phoneRegex=/^\+[1-9]{1}[0-9]{3,14}$/;

export default function MyProfile() {
   const { loggedUser, validateLogin, generateDate} = useContext(ProductContext);
   const [loaded, setLoaded] = useState(false);
   const [viewOnly, setViewOnly] = useState(true);
   const { enqueueSnackbar } = useSnackbar();
   const [adminDetails, setAdminDetails] = useState({userID:'', title:'Mr',userName:'', areaCode:'+91', 
    userPhoneNo:'', userEmailID:'', userRole:'Faculty', userAccount:'Residence', joiningDate:'', userStatus:'Active', bloodGroup:'', currentAddress:'', dateOfBirth:'', addtionalDetails:''});  
    const [newImage, setNewImage]=useState('');
    const [formType, setFormType] = useState('View');
    const [profileImage, setProfileImage] = useState(logo);
    const [newProfileImage, setNewProfileImage]=useState(logo)
 
   useEffect(()=>{
     if(loggedUser.isAuthenticated){
       setViewOnly(true);
       fetchMyProfile();
     }else{
       validateLogin();
     }
   },[loggedUser])
 
   const fetchMyProfile=async()=>{
     setLoaded(false);
     try{
      const { idToken } = (await fetchAuthSession()).tokens ?? {};
        const searchTopic="UserID";
        const searchValue=loggedUser.nickname;
        const clientID=loggedUser.website;
           await axios.get(`${config.api.invokeURL}/dashboard/officeform?fetchKey=${searchValue}&fetchOption=${searchTopic}&clientID=${clientID}`, {
            headers: {
               Authorization: idToken,
               'x-api-key':config.api.key
             }
           }).then(async(response) => {
            console.log("response : ", response.data);
             if(response.data.length>0)
             {
                 setAdminDetails(response.data[0]);
                 //setProfileDetails(response.data[0]);
                 setProfileImage(`${config.s3.imageURL}${"avatars/admins/"}${response.data[0].userID}${".jpeg"}`);
                 enqueueSnackbar("Profile loaded Successfully!",{variant : 'success'});
               setLoaded(true);
             }
             setLoaded(true);
         }).catch((error)=>{
            enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
         setLoaded(true);
       })
 
     }catch(error){
      enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
     setLoaded(true);
 
   }
 }

 const handleEnableEdit=(event)=>{
  event.preventDefault();
  setLoaded(false);
  setFormType('Edit');
  setViewOnly(false);
  setLoaded(true);
  window.scrollTo(0,0);
 }
 
 const handleDisableEdit=(event)=>{
  event.preventDefault();
  setLoaded(false);
  setViewOnly(true);
  setFormType('View');
  setLoaded(true);
  window.scrollTo(0,0);
 }

 const handleEditAccount=async(event)=>{
  event.preventDefault();
  try{
  const validationResult=validateFields("Edit");
  if(validationResult==="passed"){
    setLoaded(false);
    const todayDate=await generateDate();
    //console.log("logged User :", loggedUser);
    //const clientID=loggedUser.familyName;
    //const session = await Auth.currentSession();
    //const access_token=session.idToken.jwtToken;
    const { idToken } = (await fetchAuthSession()).tokens ?? {};
    const {userID, userName, userEmailID, title, joiningDate, areaCode, userPhoneNo, userStatus, userRole, bloodGroup, currentAddress, dateOfBirth, userAccount, addtionalDetails} = adminDetails; 
    const params={
        userID:userID,
      userEmailID:userEmailID,
      userName:userName,
      title:title,
      registeredDate:todayDate,
      joiningDate:joiningDate,
      areaCode:areaCode,
      userPhoneNo:userPhoneNo,
      userRole:userRole,
      userStatus:userStatus,
      userAccount:userAccount,
      updatedBy:loggedUser.name,
      updatedOn:todayDate,
      dateOfBirth:dateOfBirth,
      currentAddress:currentAddress,
      bloodGroup:bloodGroup,
      addtionalDetails:addtionalDetails
    }
console.log("Params : ", params);
  await axios.patch(`${config.api.invokeURL}/dashboard/officeform`,params, {  
      headers: {
        Authorization: idToken,
        'x-api-key':config.api.key
      }})
      .then(async(response)=>{
        console.log("response : ", response); 
        if(newImage){
        await postOnS3(userID);
        }
        enqueueSnackbar("Admin Account Updated successfully!",{variant:'success'});
        handleDisableEdit();
      window.scrollTo(0,0);
      setLoaded(true);
      }).catch((error)=>{
        enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'});
        window.scrollTo(0,0);
        setLoaded(true);
      })
  }
    }catch(error){
      enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'});
      window.scrollTo(0,0);
      setLoaded(true);
  }
}

const validateFields=(mode)=>{
  var returnValue="passed";
  var tphone="";
  //console.log("mode :", mode);
  //console.log("new Image", newImage);
  if(adminDetails.areaCode!==""&& adminDetails.userPhoneNo!==""){
  tphone=adminDetails.areaCode.toString()+adminDetails.userPhoneNo.toString();
  }
  if(adminDetails.userName===""){
    enqueueSnackbar("Name is mandatory.",{variant : 'info'});
    returnValue="failed";
  }else if(adminDetails.joiningDate===""){
    enqueueSnackbar("Registration Date is mandatory.",{variant : 'info'});
    returnValue="failed";
  }else if(!adminDetails.joiningDate.match(dobRegex)){
    enqueueSnackbar("Registration Date is not in proper format.",{variant : 'info'});
    returnValue="failed";
  }else if(adminDetails.userEmailID===""){
    enqueueSnackbar("Email Address is mandatory.",{variant : 'info'});
    returnValue="failed";
  }else if(!adminDetails.userEmailID.match(validRegex)){
    enqueueSnackbar("Email address is not in right format!.",{variant : 'info'});
    returnValue="failed";
  }else if(!tphone.match(phoneRegex)){
    enqueueSnackbar("Area Code and Phone Number is not in right format!.",{variant : 'info'});
    returnValue="failed";
  }else if(adminDetails.areaCode==="" || adminDetails.userPhoneNo===""){
    enqueueSnackbar("Area Code and Mobile Number is mandatory!.",{variant : 'info'});
    returnValue="failed";
  }else if(mode==="Add" && !newImage){
    enqueueSnackbar("Add Your Photo!",{variant : 'info'});
    returnValue="failed";
  }else {
returnValue="passed";
}
return returnValue;
}

const postOnS3 = async(fileName)=>{
  try{
    const newFileName=fileName+".jpeg";      
    var file = newImage;
    var blob = file.slice(0, file.size, 'image/jpeg'); 
    const newFile = new File([blob], newFileName, {type: 'image/jpeg'});
    console.log("New file : ", newFile);
    //const session = await Auth.currentSession();
    //const access_token=session.idToken.jwtToken;   
    //const clientID=loggedUser.familyName;
    const { idToken } = (await fetchAuthSession()).tokens ?? {};
    const bucketName=config.s3.bucketName;
    var keyName="images/avatars/admins/";
    const fileType="image/jpeg";
    await axios.get(`${config.api.invokeURL}/presigned/uploader?fileName=${newFileName}&bucketName=${bucketName}&keyName=${keyName}&fileType=${fileType}`,{
    //await axios.get(`${config.api.invokeURL}/presigned/uploader?fileName=${newFileName}&bucketName=${bucketName}`,{
          headers:{
              Authorization: idToken,
              'x-api-key': config.api.key
          }
      }).then(async(response)=>{
        // console.log("Response : ", response);
        enqueueSnackbar("Image successfully uploaded",{variant:'success'});
        const res=await fetch(response.data.uploadURL, { method: 'PUT',
          headers:{
              "Content-Type":"image/jpeg"
            },body: newFile});
          //  console.log("Res : ", res);
            if(res.status===200){
            setNewProfileImage(newFileName);
            }
      }).catch((error)=>{
          //console.log("error1:", error);
          enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'});
          return "Failed";
        // setDispMsg(error.message);
        // hideLoader();
      })
  }catch(error){
  //  console.log("error1:", error);
  enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'});
  return "Failed";
  }
return "Success";
}

  return (
    <div>
       <div>
        <Helmet>
          <title>My Profile - Faculty Portal - Vidyajyoti College of Theology - Delhi || Institute of Religious Studies</title>
          <meta name="description" content="My Profile - Faculty Portal - Vidyajyoti College of Theology - Delhi || Institute of Religious Studies" />
          <meta name="keywords" content="My Profile - Faculty Portal - Vidyajyoti College of Theology - Delhi || Institute of Religious Studies" /> 
        </Helmet>
         <Preloader show={loaded ? false : true} />
          <div className="d-block mb-4 mb-md-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><i className="fa fa-home" aria-hidden="true"></i></Breadcrumb.Item>
            <Breadcrumb.Item>Accounts</Breadcrumb.Item>
            <Breadcrumb.Item active>My Profile</Breadcrumb.Item>
          </Breadcrumb>
          </div>
          <h4>My Profile</h4>
          <div>
          {profileImage && loaded && <ProfileImage profileImage={profileImage} formType={formType} setImageFile={setNewImage}/>}
          <Card>
              <Card.Body>
                  <Form>
                    <Row>
                    <Col sm={2} className="mb-3">
                        <Form.Group id="areanumber">
                        <Form.Label>Title</Form.Label>
                        <Form.Select size="lg" style={{fontSize:16, borderRadius:10, padding:8}}
                          id="title"
                          value={adminDetails.title}
                          disabled={viewOnly}
                          onChange={(event)=>{setAdminDetails({...adminDetails, title:event.target.value})}}>               
                          <option value="Mr">Mr</option>
                          <option value="Mrs">Mrs</option>
                          <option value="Ms">Ms</option>
                          <option value="Sr">Sr</option>
                          <option value="Br">Br</option>
                          <option value="Fr">Fr</option>
                          <option value="Other">Other</option>
                          </Form.Select>
                      </Form.Group>
                      </Col>
                      <Col lg={10} className="mb-3">
                        <Form.Group id="firstName">
                          <Form.Label>Full Name</Form.Label>
                          <Form.Control required type="text" placeholder="Enter your name...." value={adminDetails.userName}
                            disabled={viewOnly}
                            onChange={(event)=>{setAdminDetails({...adminDetails, userName:(event.target.value).toUpperCase()})}}  
                        />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6} className="mb-3">
                        <Form.Group id="emal">
                          <Form.Label>Email</Form.Label>
                          <Form.Control required type="email" value={adminDetails.userEmailID}
                            disabled={viewOnly} placeholder='Enter your email address...'
                            onChange={(event)=>{setAdminDetails({...adminDetails, userEmailID:(event.target.value).toUpperCase()})}}
                            />
                        </Form.Group>
                      </Col>
                      <Col lg={6} className="mb-3">
                      <Form.Label>Mobile Number</Form.Label>
                      <Row>
                        <Col sm={4} className="mb-3">
                        <Form.Group id="areanumber">
                          <Form.Select size="lg" style={{fontSize:16, borderRadius:10, padding:8, width:"100%"}}
                          type="select" name="courseName"
                                            value={adminDetails.areaCode} 
                                            disabled={viewOnly}
                                            onChange={(event)=>{setAdminDetails({...adminDetails, areaCode:event.target.value})}}
                                          >
                                            {phoneCode.map(item => {
                                          return (<option key={item.Code} value={item.Code}>{item.Code}</option>);
                                        })}
                            </Form.Select>
                          </Form.Group>
                      </Col>
                      <Col sm={8} className="mb-3">
                        <Form.Group id="mnumber">
                          <Form.Control required type="number" placeholder="Enter your mobile number...." 
                                          disabled={viewOnly}
                                          value={adminDetails.userPhoneNo} onChange={(event)=>{setAdminDetails({...adminDetails, userPhoneNo:event.target.value})}}
                          />
                        </Form.Group>
                      </Col>
                      </Row>
                      </Col>    
                    </Row>
                    <Row className="align-items-center">
                      <Col lg={4} className="mb-3">
                        <Form.Group id="birthday">
                          <Form.Label>Date Of Birth</Form.Label>
                          <Form.Control type="date" value={adminDetails.dateOfBirth}
                                            disabled={viewOnly}
                                            onChange={(event)=>{setAdminDetails({...adminDetails, dateOfBirth:event.target.value})}}
                        />
                        </Form.Group>
                      </Col>
                      <Col lg={4} className="mb-3">
                        <Form.Group id="joiningDate">
                          <Form.Label>Associated From</Form.Label> <br />
                          <Form.Control type="date" value={adminDetails.joiningDate}
                                            disabled={viewOnly}
                                            onChange={(event)=>{setAdminDetails({...adminDetails, joiningDate:event.target.value})}}
                        />
                        </Form.Group>
                      </Col>
                      <Col lg={4} className="mb-3">
                        <Form.Group id="joiningDate">
                          <Form.Label>Province</Form.Label> <br />
                          <Form.Control type="text" value={adminDetails.province}
                                            disabled={viewOnly}
                                            onChange={(event)=>{setAdminDetails({...adminDetails, province:event.target.value})}}
                        />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4} className="mb-3">
                        <Form.Group id="status">
                          <Form.Label>Status</Form.Label> <br />
                          <Form.Select size="lg" style={{fontSize:16, borderRadius:10, padding:8, width:"100%"}}
                          labelId="status-label"
                          id="status"
                          variant="filled"
                          value={adminDetails.userStatus}
                          disabled={viewOnly}
                          onChange={(event)=>{setAdminDetails({...adminDetails, userStatus:event.target.value})}}                >
                          <option value="Active">Active</option>
                          <option value="In-Active">In-Active</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg={4} className="mb-3">
                        <Form.Group id="status">
                          <Form.Label>Role</Form.Label> <br />
                          <Form.Select size="lg" style={{fontSize:16, borderRadius:10, padding:8, width:"100%"}}
                          labelId="status-label"
                          id="status"
                          variant="filled"
                          value={adminDetails.userRole}
                          disabled={viewOnly}
                          onChange={(event)=>{setAdminDetails({...adminDetails, userRole:event.target.value})}}                >
                          <option value="Faculty">Faculty</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg={4} className="mb-3">
                        <Form.Group id="bgroup">
                          <Form.Label>Blood Group</Form.Label>
                          <Form.Control required type="text" value={adminDetails.bloodGroup}
                            disabled={viewOnly} placeholder='Enter your blood group....'
                            onChange={(event)=>{setAdminDetails({...adminDetails, bloodGroup:(event.target.value).toUpperCase()})}}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                    <Col lg={6} className="mb-3">
                        <Form.Group id="religion">
                          <Form.Label>Account Type</Form.Label> <br />
                          <Form.Select size="lg" style={{fontSize:16, borderRadius:10, padding:8}}
                          id="title"
                          value={adminDetails.userAccount}
                          disabled={viewOnly}
                          onChange={(event)=>{setAdminDetails({...adminDetails, userAccount:event.target.value})}}>               
                          <option value="Residence">Residence</option>
                          <option value="College">College</option>
                          </Form.Select>
                        </Form.Group>
                        </Col>
                    <Col lg={6} className="mb-3">
                        <Form.Group id="religion">
                          <Form.Label>Current Address</Form.Label> <br />
                          <Form.Control type="text" value={adminDetails.currentAddress}
                                            disabled={viewOnly}
                                            onChange={(event)=>{setAdminDetails({...adminDetails, currentAddress:event.target.value})}}
                        />
                        </Form.Group>
                        </Col>
                        </Row>
                        <Row>
                        <Form.Group id="denomination">
                          <Form.Label>Addtional Details</Form.Label>
                          <Form.Control required as="textarea" rows={5} value={adminDetails.addtionalDetails}
                            disabled={viewOnly} placeholder='Enter your parish & diocese details....'
                            onChange={(event)=>{setAdminDetails({...adminDetails, addtionalDetails:event.target.value})}}
                          />
                        </Form.Group>
                    </Row>
                  </Form>
              </Card.Body>
          </Card>
          <div style={{display:"flex", justifyContent:"center", mt:"20px"}}>
              {viewOnly?<Button type="submit" className='buttonStyle' onClick={event=>handleEnableEdit(event)}>
              Edit
              </Button>:<><Button type="submit" className='buttonStyle' onClick={event=>handleEditAccount(event)}>
              Update
              </Button><Button type="submit" className='buttonStyle' onClick={event=>handleDisableEdit(event)}>
              Cancel
              </Button></>}
          </div>
        </div>
      </div>
    </div>
  )
}
